import Counter from "utils/Counter";
import {Link} from "react-router-dom";

const MintSec = () => {
    return (
        <section id="mint-sec">
            <div className="container">
                <div className="row story-row count-row">
                    <div className="counter-left-heading">
                        <h2>12:00 GMT 14th JANUARY. </h2>
                        <Link to="/stake" className="cta presale_btn">Jungle Bonds</Link>
                        <br/>
                        (........)
                    </div>
                    <div className="hero-counter" data-aos="fade-up">
                        <Counter time="January 14 2022 20:00:00" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MintSec
